import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const ItalicIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ItalicIcon", ...props, ref: ref, children: _jsx("polygon", { fill: "currentColor", points: "5.33 14 6.91 14 10.67 0 9.09 0 5.33 14" }) })));
ItalicIcon.displayName = "ItalicIcon";
